import { Injectable, EventEmitter } from '@angular/core';
import { Observable, AsyncSubject ,Subject } from 'rxjs';
import { multicast } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class TraductorService {

  private subject = new Subject<number>();
  
  constructor(

  ) {
  }
  // se crea el evento que recibe la data y se asigna a la variable el evento generado desde el componente barra
  sendEvent(evento: any) {
    this.subject.next(evento);
  }
  // Observable
  getEvento(): Observable<number> {
    return this.subject.asObservable();
    
  }

}
